<div class="card vazio" *ngIf="!filtro">
  <b>Escolha a agenda</b>
  {{ dica }}
</div>

<ng-container *ngIf="filtro">
  <!-- Barra de ações: os modais que ela abre ficam com a tela -->
  <div class="card acoes" role="toolbar" aria-label="Ações da grade">
    <span class="sel-info">
      <ng-container *ngIf="selecionadas.length; else nenhum">
        {{ selecionadas.length }} selecionado{{ selecionadas.length > 1 ? 's' : '' }} ·
        <button type="button" class="link" (click)="limparSelecao()">limpar</button>
      </ng-container>
      <ng-template #nenhum>Nenhum horário selecionado</ng-template>
    </span>
    <button type="button" class="btn btn-primario btn-sm" [disabled]="!podeNovo" [title]="motivoSemNovo" (click)="novo()">
      <svg class="i sm" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></svg>Novo agendamento
    </button>
    <button
      type="button"
      class="btn btn-secundario btn-sm"
      [disabled]="!podeEncaixe"
      [title]="motivoEncaixe"
      (click)="pedirEncaixe()"
    >
      <svg class="i sm" viewBox="0 0 24 24"><path d="M13 2 4 14h7l-1 8 9-12h-7z" /></svg>Encaixe
    </button>
    <button
      *ngIf="supervisor"
      type="button"
      class="btn btn-secundario btn-sm"
      [disabled]="!reservaAlvo"
      title="Um horário livre ou reservado, sem paciente"
      (click)="reservarOuLiberar()"
    >
      <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 4 6v6c0 4.5 3.4 8.3 8 9 4.6-.7 8-4.5 8-9V6z" /></svg>
      {{ reservaAlvo?.ieStatusAgenda === 'R' ? 'Liberar reserva' : 'Reservar' }}
    </button>
    <span class="espaco"></span>
    <button
      type="button"
      class="btn btn-contorno btn-sm"
      [disabled]="!!motivoAcao('alterar')"
      [title]="motivoAcao('alterar') || 'Alterar os agendamentos selecionados'"
      (click)="pedirAcao('alterar')"
    >
      <svg class="i sm" viewBox="0 0 24 24"><path d="M4 20h4L19 9l-4-4L4 16z" /></svg>Alterar{{ marcadas.length > 1 ? ' (' + marcadas.length + ')' : '' }}
    </button>
    <button
      type="button"
      class="btn btn-contorno btn-sm"
      [disabled]="!!motivoAcao('transferir')"
      [title]="motivoAcao('transferir') || 'Transferir / remarcar os selecionados com status Normal ou Confirmada'"
      (click)="pedirAcao('transferir')"
    >
      <svg class="i sm" viewBox="0 0 24 24"><path d="M7 7h13l-4-4M17 17H4l4 4" /></svg>Transferir
    </button>
    <button
      type="button"
      class="btn btn-contorno btn-sm"
      [disabled]="!!motivoAcao('trocarPaciente')"
      [title]="motivoAcao('trocarPaciente') || 'Trocar o paciente do agendamento selecionado'"
      (click)="pedirAcao('trocarPaciente')"
    >
      <svg class="i sm" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M18 14a6 6 0 0 1 3.5 6" /></svg>Trocar paciente
    </button>
    <button
      type="button"
      class="btn btn-contorno btn-sm"
      [disabled]="!!motivoAcao('desvincular')"
      [title]="motivoAcao('desvincular') || 'Desvincular a conta do agendamento selecionado'"
      (click)="pedirAcao('desvincular')"
    >
      <svg class="i sm" viewBox="0 0 24 24"><path d="M9 15 15 9M10 6l1.5-1.5a4.2 4.2 0 0 1 6 6L16 12M8 12l-1.5 1.5a4.2 4.2 0 0 0 6 6L14 18" /></svg>Desvincular
    </button>
    <button
      type="button"
      class="btn btn-contorno btn-sm perigo"
      [disabled]="!!motivoAcao('cancelar')"
      [title]="motivoAcao('cancelar') || 'Cancelar os selecionados com status Normal ou Confirmada'"
      (click)="pedirAcao('cancelar')"
    >
      <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>Cancelar
    </button>
    <span class="colunas-ancora">
      <button
        type="button"
        class="btn btn-contorno btn-sm"
        [disabled]="!colunasProntas"
        [title]="colunasProntas ? 'Escolher e ordenar as colunas da grade' : 'Carregando as colunas salvas...'"
        [attr.aria-expanded]="seletorAberto"
        (click)="seletorAberto = !seletorAberto"
      >
        <svg class="i sm" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16M15 4v16" /></svg>Colunas
      </button>
      <ng-container *ngIf="seletorAberto">
        <div class="seletor-fundo" (click)="seletorAberto = false"></div>
        <div class="seletor" role="dialog" aria-label="Colunas da grade">
          <div class="seletor-cab">
            <span class="cab-ico" aria-hidden="true">
              <svg class="i sm" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16M15 4v16" /></svg>
            </span>
            <div>
              <b>Colunas</b>
              <span class="sub2">Arraste ou use as setas para reordenar. Desmarque para ocultar.</span>
            </div>
          </div>
          <ul class="seletor-lista">
            <li
              *ngFor="let it of itensColunas; let primeiro = first; let ultimo = last; trackBy: trackItemColuna"
              draggable="true"
              [class.arrastando]="arrastando === it.def.key"
              [attr.data-coluna]="it.def.key"
              (dragstart)="iniciarArraste(it.def.key, $event)"
              (dragend)="arrastando = null"
              (dragover)="$event.preventDefault()"
              (drop)="soltarEm(it.def.key, $event)"
            >
              <span class="alca" aria-hidden="true">⋮⋮</span>
              <label>
                <input
                  type="checkbox"
                  [checked]="it.visivel"
                  [disabled]="it.def.sempreVisivel"
                  [title]="it.def.sempreVisivel ? 'Coluna sempre visível' : ''"
                  (change)="alternarColuna(it.def.key)"
                />
                {{ it.def.rotulo }}
              </label>
              <button type="button" class="btn-ico mini" title="Subir" [disabled]="primeiro" (click)="moverColuna(it.def.key, -1)">
                <svg class="i sm" viewBox="0 0 24 24"><path d="m6 15 6-6 6 6" /></svg>
              </button>
              <button type="button" class="btn-ico mini" title="Descer" [disabled]="ultimo" (click)="moverColuna(it.def.key, 1)">
                <svg class="i sm" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" /></svg>
              </button>
            </li>
          </ul>
          <div class="seletor-rodape">
            <button type="button" class="btn btn-contorno btn-sm" (click)="restaurarColunas()">Restaurar padrão</button>
            <button type="button" class="btn btn-primario btn-sm" (click)="seletorAberto = false">Fechar</button>
          </div>
        </div>
      </ng-container>
    </span>
    <span class="erro-colunas" *ngIf="erroColunas" role="status">{{ erroColunas }}</span>
    <button type="button" class="btn-ico" title="Legendas" [attr.aria-pressed]="legendaAberta" (click)="legendaAberta = !legendaAberta">
      <svg class="i" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
    </button>
    <button type="button" class="btn-ico" title="Atualizar" (click)="recarregar(true)">
      <svg class="i" viewBox="0 0 24 24"><path d="M20 11a8 8 0 0 0-14.6-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.6 4.5L20 16M20 20v-4h-4" /></svg>
    </button>
  </div>

  <!-- Alertas da agenda -->
  <div class="alertas" *ngIf="observacao || bloqueios.length || turnosVisiveis.length">
    <div class="alerta info" *ngIf="observacao">
      <svg class="i sm" viewBox="0 0 24 24"><path d="M6 3h9l4 4v14H6z" /><path d="M9 12h7M9 16h5" /></svg>
      <div><b>Observação da agenda:</b> {{ observacao }}</div>
      <button type="button" class="btn-ico fechar" title="Ocultar" (click)="fecharAlerta('obs-' + filtro.cdAgenda)">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="alerta bad" *ngIf="bloqueios.length" role="alert">
      <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg>
      <div>
        <b>{{ bloqueioTotal ? 'Bloqueio total' : 'Bloqueio parcial' }}:</b>
        <span *ngFor="let b of bloqueios; let ult = last">{{ descreverBloqueio(b) }}{{ ult ? '' : ' | ' }}</span>.
        <ng-container *ngIf="bloqueioTotal"> Novo agendamento e encaixe desabilitados nesta data.</ng-container>
      </div>
    </div>

    <div class="alerta" [ngClass]="severidadeTurno" *ngIf="turnosVisiveis.length">
      <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
      <div>
        <b>Turno perto do fim:</b>
        <span *ngFor="let t of turnosVisiveis; let ult = last">
          {{ t.dsAgenda }}<ng-container *ngIf="t.nmMedico"> ({{ t.nmMedico }})</ng-container>,
          {{ t.tipo }}<ng-container *ngIf="t.tipoTurno"> {{ t.tipoTurno }}</ng-container><ng-container *ngIf="t.hrInicial && t.hrFinal"> {{ t.hrInicial }} às {{ t.hrFinal }}</ng-container>,
          encerra em {{ t.dtFim }} ({{ t.diasRestantes }} dia{{ t.diasRestantes === 1 ? '' : 's' }}){{ ult ? '.' : ';' }}
        </span>
        Depois disso não há horários gerados.
      </div>
      <button type="button" class="btn-ico fechar" title="Ocultar" (click)="fecharAlerta('turno-' + filtro.cdAgenda)">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>
  </div>

  <!-- Erro da carga -->
  <div class="card vazio" *ngIf="erroCarga && !carregando">
    <b>Não foi possível carregar a agenda</b>
    {{ erroCarga }}
    <div class="linha-vazio"><button type="button" class="btn btn-contorno btn-sm" (click)="tentarDeNovo()">Tentar de novo</button></div>
  </div>

  <!-- Dia sem horário gerado -->
  <div class="card vazio" *ngIf="diaSemHorario && !carregando && !erroCarga">
    <b>Sem horários neste dia</b>
    Esta agenda não tem horários gerados nesta data. Use a visão mensal para achar dias com vaga.
    <div class="linha-vazio">
      <button type="button" class="btn btn-contorno btn-sm" (click)="diaVizinho(-1)">Dia anterior</button>
      <button type="button" class="btn btn-contorno btn-sm" (click)="diaVizinho(1)">Dia seguinte</button>
    </div>
  </div>

  <ng-container *ngIf="!erroCarga && (carregando || !diaSemHorario)">
    <!-- Resumo do dia -->
    <div class="resumo" *ngIf="chips.length && !carregando">
      <div class="kpi" *ngFor="let c of chips" [ngClass]="c.tom" [title]="c.dica || ''">
        <b>{{ c.valor }}</b><span>{{ c.rotulo }}</span><small *ngIf="c.dica">{{ c.dica | lowercase }}</small>
      </div>
      <div class="medico-unico" *ngIf="medicoNoResumo" title="Médico de todos os horários desta agenda">
        <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" /><path d="M5 21a7 7 0 0 1 14 0" /></svg>{{ medicoNoResumo }}
      </div>
    </div>
    <div class="resumo" *ngIf="carregando" aria-hidden="true">
      <div class="kpi esq" *ngFor="let _ of [1, 2, 3, 4]"><i class="barra-esq"></i></div>
    </div>

    <div class="card">
      <div class="tabela-wrap" #tabelaWrap (scroll)="rolagemGrade.emit()">
        <table class="grade" [attr.aria-busy]="carregando">
          <thead>
            <tr>
              <th class="col-chk fixa" [class.fixa-ult]="!ultimaFixa">
                <input
                  type="checkbox"
                  title="Selecionar todos os agendados"
                  aria-label="Selecionar todos os agendados"
                  [checked]="todasMarcadas"
                  [disabled]="carregando"
                  (change)="marcarTodas($any($event.target).checked)"
                />
              </th>
              <th
                *ngFor="let c of colunasGrade; trackBy: trackColuna"
                [ngClass]="'c-' + c.key"
                [class.ord]="!!c.ordenacao"
                [class.fixa]="esquerda(c.key) !== null"
                [class.fixa-ult]="ultimaFixa === c.key"
                [style.left.px]="esquerda(c.key)"
                [attr.data-coluna]="c.key"
                [title]="c.rotulo"
                (click)="c.ordenacao && ordenar(c.ordenacao)"
              >{{ c.cabecalho }}{{ c.ordenacao ? indicador(c.ordenacao) : '' }}</th>
              <th class="col-menu"></th>
            </tr>
          </thead>

          <tbody *ngIf="carregando">
            <tr class="esq" *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]">
              <td [attr.colspan]="colunas"><i class="barra-esq"></i></td>
            </tr>
          </tbody>

          <tbody *ngIf="!carregando">
            <tr *ngIf="!linhas.length">
              <td [attr.colspan]="colunas" class="vazio">
                <b>Nenhum horário com estes filtros</b>
                Remova um filtro acima para ver mais horários.
              </td>
            </tr>
            <tr
              *ngFor="let l of linhas; trackBy: trackLinha"
              [class.livre]="ehLivre(l)"
              [class.bloq]="ehBloqueado(l)"
              [class.reserv]="l.ieStatusAgenda === 'R'"
              [class.canc]="ehCancelado(l)"
              [class.sel]="estaSelecionada(l)"
              [class.inerte]="!selecionavel(l)"
              [title]="ehBloqueado(l) ? 'Horário bloqueado' + (l.dsBloqueio ? ': ' + l.dsBloqueio : '') : ''"
              (click)="clicarLinha(l)"
              (contextmenu)="aoContextMenu(l, $event)"
            >
              <td class="col-chk fixa" [class.fixa-ult]="!ultimaFixa">
                <input
                  type="checkbox"
                  [attr.aria-label]="'Selecionar ' + (l.hrInicio || '')"
                  [checked]="estaSelecionada(l)"
                  [disabled]="!selecionavel(l)"
                  (click)="$event.stopPropagation()"
                  (change)="alternar(l, $any($event.target).checked)"
                />
              </td>
              <ng-container *ngFor="let c of colunasGrade; trackBy: trackColuna">
              <ng-container [ngSwitch]="c.key">
              <td
                *ngSwitchCase="'hora'"
                class="c-hora"
                [class.fixa]="esquerda('hora') !== null"
                [class.fixa-ult]="ultimaFixa === 'hora'"
                [style.left.px]="esquerda('hora')"
              >
                <span class="hora">{{ l.hrInicio }}</span>
                <span class="tag enc" *ngIf="l.ieEncaixe === 'S'" title="Encaixe">ENC</span>
                <span class="tag prio" *ngIf="l.iePrioridade === 'S'" title="Paciente priorizado">PRIOR</span>
              </td>
              <td
                *ngSwitchCase="'tipo'"
                class="c-tipo"
                [class.fixa]="esquerda('tipo') !== null"
                [class.fixa-ult]="ultimaFixa === 'tipo'"
                [style.left.px]="esquerda('tipo')"
              >
                <span class="tag" [class.exam]="l.tipo === 'EXAME'" [class.cons]="l.tipo !== 'EXAME'">{{ l.tipo }}</span>
              </td>
              <td *ngSwitchCase="'senha'">{{ l.dsSenha }}</td>
              <td *ngSwitchCase="'sequencia'">{{ temPaciente(l) ? l.nrSequencia : '' }}</td>
              <td *ngSwitchCase="'dt_agenda'">{{ formatarData(l.dtAgenda) }}</td>
              <td *ngSwitchCase="'duracao'">{{ l.nrMinutoDuracao !== null ? l.nrMinutoDuracao + "'" : '' }}</td>
              <td *ngSwitchCase="'espera'">
                <span
                  *ngIf="classeEspera(l) !== null"
                  class="esp"
                  [ngClass]="classeEspera(l)"
                  [title]="rotuloEspera(l)"
                >
                  <b class="esp-num">{{ esperaPrincipal(l.qtMinEspera!) }}</b>
                  <small class="esp-sub" *ngIf="esperaSub(l.qtMinEspera!)">{{ esperaSub(l.qtMinEspera!) }}</small>
                </span>
              </td>
              <td *ngSwitchCase="'status_agenda'"><span class="pill" [ngClass]="classeStatus(l.ieStatusAgenda)">{{ l.dsStatusAgenda || l.ieStatusAgenda }}</span></td>
              <td *ngSwitchCase="'classif'" class="c-classif">
                <span *ngIf="l.dsClassifAgenda" class="tx" [title]="l.dsClassifAgenda"><span class="dot" [style.background]="corClassif(l)"></span>{{ l.dsClassifAgenda }}</span>
              </td>
              <td *ngSwitchCase="'encaixe'">{{ l.ieEncaixe === 'S' ? 'Sim' : '' }}</td>
              <td *ngSwitchCase="'retorno'">{{ l.ieRetorno === 'S' ? 'Sim' : '' }}</td>
              <td *ngSwitchCase="'transferido'" class="c-transferido">
                <span
                  *ngIf="l.nmUsuarioCopiaTrans"
                  class="tx"
                  [title]="'Transferido por ' + l.nmUsuarioCopiaTrans + (l.dtCopiaTrans ? ' em ' + l.dtCopiaTrans : '')"
                ><span class="tag tr">TRANSF</span> {{ l.nmUsuarioCopiaTrans }}</span>
              </td>
              <td
                *ngSwitchCase="'paciente'"
                class="c-paciente pac"
                [class.fixa]="esquerda('paciente') !== null"
                [class.fixa-ult]="ultimaFixa === 'paciente'"
                [style.left.px]="esquerda('paciente')"
              >
                <ng-container *ngIf="temPaciente(l); else semPaciente">
                  <span class="cel2" [title]="l.paciente.nmPaciente + (l.paciente.nrCpf ? ' · CPF ' + formatarCpf(l.paciente.nrCpf) : '')">
                    <span class="nome">{{ l.paciente.nmPaciente }}</span>
                    <span class="sub2 integral" *ngIf="subPaciente(l)">{{ subPaciente(l) }}</span>
                  </span>
                </ng-container>
                <ng-template #semPaciente>
                  <ng-container *ngIf="ehBloqueado(l); else naoBloqueado">
                    <span class="cel2" [title]="'Bloqueado' + (l.dsBloqueio ? ': ' + l.dsBloqueio : '')">
                      <span class="nome">Bloqueado</span><span class="sub2" *ngIf="l.dsBloqueio">{{ l.dsBloqueio }}</span>
                    </span>
                  </ng-container>
                  <ng-template #naoBloqueado>
                    <ng-container *ngIf="l.ieStatusAgenda === 'R'; else livre">
                      <span class="cel2"><span class="nome">Reservado</span><span class="sub2" *ngIf="l.nmUsuarioOrig">por {{ l.nmUsuarioOrig }}</span></span>
                    </ng-container>
                    <ng-template #livre>
                      <button
                        *ngIf="ehLivre(l)"
                        type="button"
                        class="btn-agendar"
                        [disabled]="!liberaNovo"
                        [title]="liberaNovo ? 'Agendar neste horário' : motivoSemNovo"
                        (click)="$event.stopPropagation(); agendar(l)"
                      >+ Agendar</button>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </td>
              <td *ngSwitchCase="'dt_nascimento'">{{ l.dtNascimento }}</td>
              <td *ngSwitchCase="'idade'">{{ l.idade !== null ? l.idade + ' anos' : '' }}</td>
              <td *ngSwitchCase="'telefone'">{{ l.nrTelefone }}</td>
              <td *ngSwitchCase="'email'" class="c-email"><span class="tx" [title]="l.dsEmail || ''">{{ l.dsEmail }}</span></td>
              <td *ngSwitchCase="'convenio'" class="c-convenio">
                <ng-container *ngIf="temPaciente(l) && exibicaoConvenio(l.convenio.cdConvenio, l.convenio.dsConvenio, l.categoria.dsCategoria) as ec">
                  <span class="cel2" [title]="ec.tooltip">
                    <span class="linha1">{{ ec.linha1 }}</span>
                    <span class="sub2" *ngIf="ec.sub">{{ ec.sub }}</span>
                  </span>
                </ng-container>
              </td>
              <td *ngSwitchCase="'dependente'" class="c-dependente">
                <span class="tag dep" *ngIf="l.dependente === true">Dependente</span>
                <span class="titular" *ngIf="l.dependente === false">Titular</span>
              </td>
              <td *ngSwitchCase="'categoria'" class="c-categoria">
                <span class="tx" *ngIf="temPaciente(l)" [title]="l.categoria.dsCategoria || ''">{{ l.categoria.dsCategoria }}</span>
              </td>
              <td *ngSwitchCase="'atendimento'">{{ l.paciente.nrAtendimento }}</td>
              <td *ngSwitchCase="'especialidade'" class="c-especialidade">
                <span class="tx" [title]="l.especialidade.dsEspecialidade || ''">{{ l.especialidade.dsEspecialidade }}</span>
              </td>
              <td *ngSwitchCase="'agenda'" class="c-agenda"><span class="tx" [title]="l.dsAgenda || ''">{{ l.dsAgenda }}</span></td>
              <td *ngSwitchCase="'medico'" class="c-medico">
                <span class="tx" [class.apagado]="!temPaciente(l)" [title]="l.medico.nmMedico || l.medicoAgenda.nmMedico || ''">{{ l.medico.nmMedico || l.medicoAgenda.nmMedico }}</span>
              </td>
              <td *ngSwitchCase="'exame'" class="c-exame"><span class="tx" [title]="l.dsExame || ''">{{ l.dsExame }}</span></td>
              <td *ngSwitchCase="'dt_agendamento'">{{ l.dtAgendamento }}</td>
              <td *ngSwitchCase="'dt_confirmacao'">{{ l.dtConfirmacao }}</td>
              <td *ngSwitchCase="'dt_aguardando'">{{ l.dtAguardando }}</td>
              <td *ngSwitchCase="'dt_consulta'">{{ l.dtConsulta }}</td>
              <td *ngSwitchCase="'dt_atendido'">{{ l.dtAtendido }}</td>
              <td *ngSwitchCase="'dt_fim_atend'">{{ l.dtFimAtendimento }}</td>
              <td *ngSwitchCase="'dt_cancelamento'">{{ l.dtCancelamento }}</td>
              <td *ngSwitchCase="'usu_origem'" class="c-usu">
                <span class="cel2" *ngIf="temPaciente(l)" [title]="l.nmUsuarioOrig || ''">
                  <span class="linha1">{{ l.nmUsuarioOrig }}</span>
                  <span class="sub2" *ngIf="subAgendadoPor(l.dtAgendamento)">{{ subAgendadoPor(l.dtAgendamento) }}</span>
                </span>
              </td>
              <td *ngSwitchCase="'usu_confirm'" class="c-usu"><span class="tx" [title]="l.nmUsuarioConfirm || ''">{{ l.nmUsuarioConfirm }}</span></td>
              <td *ngSwitchCase="'usu_aguardando'" class="c-usu"><span class="tx" [title]="l.nmUsuarioAguardando || ''">{{ l.nmUsuarioAguardando }}</span></td>
              <td *ngSwitchCase="'usu_consulta'" class="c-usu"><span class="tx" [title]="l.nmUsuarioConsulta || ''">{{ l.nmUsuarioConsulta }}</span></td>
              <td *ngSwitchCase="'usu_atendido'" class="c-usu"><span class="tx" [title]="l.nmUsuarioAtendido || ''">{{ l.nmUsuarioAtendido }}</span></td>
              <td *ngSwitchCase="'usu_fim_atend'" class="c-usu"><span class="tx" [title]="l.usuarioFimAtend || ''">{{ l.usuarioFimAtend }}</span></td>
              <td *ngSwitchCase="'usu_cancelamento'" class="c-usu"><span class="tx" [title]="l.nmUsuarioCancelamento || ''">{{ l.nmUsuarioCancelamento }}</span></td>
              <td *ngSwitchCase="'observacao'" class="c-observacao">
                <button
                  *ngIf="l.dsObservacao"
                  type="button"
                  class="btn-ico obs"
                  [title]="l.dsObservacao"
                  [attr.aria-label]="'Observação: ' + l.dsObservacao"
                  (click)="$event.stopPropagation()"
                >
                  <svg class="i sm" viewBox="0 0 24 24"><path d="M6 3h9l4 4v14H6z" /><path d="M9 12h7M9 16h5" /></svg>
                </button>
              </td>
              <td *ngSwitchCase="'motivo_cancelamento'" class="c-motivo"><span class="tx" [title]="l.cdMotivoCancelamento || ''">{{ l.cdMotivoCancelamento }}</span></td>
              <td *ngSwitchDefault></td>
              </ng-container>
              </ng-container>
              <td class="col-menu">
                <button
                  *ngIf="selecionavel(l)"
                  type="button"
                  class="btn-ico"
                  title="Ações"
                  aria-label="Ações do horário"
                  (click)="abrirMenu(l, $event)"
                >
                  <svg class="i" viewBox="0 0 24 24"><circle cx="12" cy="5" r="1.2" /><circle cx="12" cy="12" r="1.2" /><circle cx="12" cy="19" r="1.2" /></svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="legenda" *ngIf="legendaAberta">
        <div>
          <h4>Status</h4>
          <div class="itens">
            <span *ngFor="let s of statusLegenda" class="pill" [ngClass]="classeStatus(s.valor)">{{ s.rotulo }}</span>
          </div>
        </div>
        <div>
          <h4>Classificação</h4>
          <div class="itens">
            <span *ngFor="let c of legenda" class="nowrap"><span class="dot" [style.background]="c.cor"></span>{{ c.rotulo }}</span>
            <span class="nowrap"><span class="hachura"></span>Horário bloqueado</span>
            <span class="nowrap"><span class="tag enc">ENC</span> encaixe</span>
            <span class="nowrap"><span class="tag tr">TRANSF</span> transferido</span>
          </div>
        </div>
      </div>

      <div class="rodape-grade">
        <span>{{ faixa }} · o resumo conta a agenda do dia inteira, não só a grade filtrada</span>
        <span class="espera-leg">
          Espera: neutra até 29 min · <b class="esp amb">âmbar 30–59</b> · <b class="esp verm">vermelha 60+</b>
        </span>
        <span class="paginas" *ngIf="totalPaginas > 1">
          <button type="button" class="btn-ico" title="Página anterior" [disabled]="pagina <= 1 || carregando" (click)="irPagina(pagina - 1)">
            <svg class="i sm" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>
          </button>
          {{ pagina }} / {{ totalPaginas }}
          <button type="button" class="btn-ico" title="Próxima página" [disabled]="pagina >= totalPaginas || carregando" (click)="irPagina(pagina + 1)">
            <svg class="i sm" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>
          </button>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>
